import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

import './ToggleConditionsButton.custom.scss';

function getInfo(showConditions) {
  if (showConditions) {
    return {
      icon: 'eye-hide',
      label: 'Hide',
    };
  }

  return {
    icon: 'eye',
    label: 'Show',
  };
}

export default function ToggleConditionsButton(props) {
  const { isReactionsContext, showConditions, toggleConditions } = props;

  if (!isReactionsContext) {
    return null;
  }

  const { icon, label } = getInfo(showConditions);

  return (
    <Button
      id="toggleConditions"
      onClick={() => {
        toggleConditions();
      }}
      title="Toggle Conditions"
      buttonConfig={{
        className: 'result-toolbar-toggle-conditions-button',
        label: `${label} Conditions`,
        type: 'link',
        size: 'tiny',
        e2eName: 'conditions',
      }}
      iconConfig={{
        position: 'before',
        name: icon,
        size: 'sm',
      }}
    />
  );
}

ToggleConditionsButton.propTypes = {
  showConditions: PropTypes.bool,
  toggleConditions: PropTypes.func.isRequired,
  isReactionsContext: PropTypes.bool,
};
